import Icon from '@encodium/rp-ui/components/icon';

/**
 * Figma “Icon (Light) with Overlay”: 50% black overlay + centered white cube3dRotation.
 * Icon color via SCSS `currentColor`. Size via Icon `width={60}` (Figma 60px glyph).
 */
export default function GalleryThumb3D() {
	return (
		<span className="product-media-gallery__thumb-3d">
			<span className="product-media-gallery__thumb-3d-overlay" aria-hidden="true" />
			<span className="product-media-gallery__thumb-3d-icon" aria-hidden="true">
				<Icon color="currentColor" name="cube3dRotation" width={60} />
			</span>
		</span>
	);
}

GalleryThumb3D.displayName = 'GalleryThumb3D';
